import { Injectable } from "@angular/core";

import { AamsGameDataState } from "../state";

import { AamsGameDataContextState } from "./aams-game-data.model";

@Injectable({
	providedIn: "root",
})
export class AamsGameDataSelector {
	getAll() {
		return (state: AamsGameDataState): AamsGameDataContextState => state.gamingAamsGameData.aamsGameData;
	}

	getAamsSessionId() {
		return (state: AamsGameDataState): string => state.gamingAamsGameData.aamsGameData.activeGame.aamsSessionId;
	}

	getAamsTicketId() {
		return (state: AamsGameDataState): string => state.gamingAamsGameData.aamsGameData.activeGame.aamsTicketId;
	}

	getAamsOnlyFreeSpinAllowed() {
		return (state: AamsGameDataState): string =>
			state.gamingAamsGameData.aamsGameData.activeGame.aamsOnlyFreeSpinAllowed;
	}

	getAamsSessionAmount() {
		return (state: AamsGameDataState): string => state.gamingAamsGameData.aamsGameData.activeGame.aamsSessionAmount;
	}

	getAamsCurrencyCode() {
		return (state: AamsGameDataState): string => state.gamingAamsGameData.aamsGameData.activeGame.aamsCurrencyCode;
	}

	getAamsMoneyType() {
		return (state: AamsGameDataState): string => state.gamingAamsGameData.aamsGameData.activeGame.aamsMoneyType;
	}

	getHistoryUrl() {
		return (state: AamsGameDataState): string => state.gamingAamsGameData.aamsGameData.activeGame.historyUrl;
	}

	getAdditionalParameters() {
		return (state: AamsGameDataState): Record<string, string> =>
			state.gamingAamsGameData.aamsGameData.additionalParameters;
	}

	getPath() {
		return (state: AamsGameDataState): string => state.gamingAamsGameData.aamsGameData.path;
	}

	isSessionDisplayed() {
		return (state: AamsGameDataState): boolean => state.gamingAamsGameData.aamsGameData.isSessionDisplayed;
	}
}
